<div class="main-sidebar">
        <div [hidden]="showMenu">
                <div class="sidebar-header">
                        <a class="logo-text">
                                <div class="logo-img"><img src="../../assets/images/logo.png" alt="logo" /></div>
                        </a>
                </div>
                <ul>
                        <li (click)="changeNavItem(item)" [ngClass]="{ active: item.isActive }" class="nav-item"
                                *ngFor="let item of navigation"><a [routerLink]="item?.url"><i
                                                class="{{item.icon}}"></i> <span
                                                class="menu-title">{{item?.label}}</span></a>
                        </li>
                </ul>
                <div class="last-child">Logged in as <strong>{{currentUser?.roles}}</strong></div>
        </div>
</div>